export const TERMS_ACCEPTANCE_REQUIRED = "TERMS_ACCEPTANCE_REQUIRED";

export const TERMS_ACCEPTANCE_REQUIRED_MESSAGE =
  "Current Terms & Conditions must be accepted before adding a payment method.";

type ApiErrorBody = {
  error?: string;
  message?: string | string[];
};

function errorBody(error: unknown): ApiErrorBody | undefined {
  return (error as { response?: { data?: ApiErrorBody } })?.response?.data;
}

function messageFromBody(body?: ApiErrorBody): string | undefined {
  const message = body?.message;
  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }
  if (Array.isArray(message)) {
    const joined = message
      .filter(
        (part): part is string => typeof part === "string" && !!part.trim(),
      )
      .map((part) => part.trim())
      .join(", ");
    return joined || undefined;
  }
  return undefined;
}

/**
 * Returns the user-facing message when adding a card is blocked on unsigned
 * Terms. Null when the error is something else.
 */
export function getTermsAcceptanceRequiredMessage(
  error: unknown,
): string | null {
  const body = errorBody(error);
  const message = messageFromBody(body);
  const isCode = body?.error === TERMS_ACCEPTANCE_REQUIRED;
  const isMessage =
    typeof message === "string" &&
    /terms & conditions must be accepted/i.test(message);
  if (!isCode && !isMessage) {
    return null;
  }
  return message || TERMS_ACCEPTANCE_REQUIRED_MESSAGE;
}
